import { useCallback, useSyncExternalStore } from "react";

/** Avoid mounting desktop-only trees in a mobile viewport (CSS hiding doesn't). */
export function useMinWidth(width: number): boolean {
  const query = `(min-width: ${width}px)`;
  const subscribe = useCallback((notify: () => void) => {
    const media = window.matchMedia(query);
    media.addEventListener("change", notify);
    return () => media.removeEventListener("change", notify);
  }, [query]);
  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);
  return useSyncExternalStore(
    subscribe,
    getSnapshot,
    () => false
  );
}